


















import { deepEqual } from '@empathybroker/deep-equal';

import { ComponentOptions } from 'vue/types/options';
import { Vue } from 'vue/types/vue';

import { AuditDetailField } from '../../../models';

import AuditDetails from './audit-details.component.vue';

interface DetailElement {
  id: string;
  previousValue?: any;
  nextValue?: any;
}

interface ChangingElements {
  created: any[];
  updated: any[];
  deleted: any[];
  unmodified: any[];
}

export default {
  name: 'configuration-audit-details',
  props: {
    audit: {
      type: Object,
      required: true
    },
    ignoredFields: {
      type: Array,
      default: () => (AuditDetails as ComponentOptions<Vue>).props['ignoredFields'].default().concat(['ranking'])
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    AuditDetails
  },
  methods: {
    getChangingElementsText(elementsDetailField: AuditDetailField): string {
      return Object.entries(this.getChangingElements(elementsDetailField))
        .reduce((changingElementsTexts: string[], [changingElementsKey, changingElementsValues]: [string, any[]]) => {
          if ((changingElementsKey !== 'unmodified') && !!changingElementsValues.length) {
            changingElementsTexts.push(
              this.$epb.utils.compileMessage(this.messages.changingElements[changingElementsKey], {
                count: changingElementsValues.length
              }));
          }
          return changingElementsTexts;
        }, []).join(', ');
    },
    getChangingElements: function (elementsDetailField: AuditDetailField): ChangingElements {
      return this.getElements(elementsDetailField).reduce((changingElements: ChangingElements, element: DetailElement) => {
        if (!element.previousValue) {
          changingElements.created.push(element);
        } else if (!element.nextValue) {
          changingElements.deleted.push(element);
        } else if (!deepEqual(element.previousValue, element.nextValue)) {
          changingElements.updated.push(element);
        } else {
          changingElements.unmodified.push(element);
        }
        return changingElements;
      }, {
        created: [],
        updated: [],
        deleted: [],
        unmodified: []
      });
    },
    getElements: function (elementsDetailField: AuditDetailField): DetailElement[] {
      const elements = [];
      const previousElements = (elementsDetailField.previousValue || []);
      previousElements.forEach(previousElement => {
        elements.push({
          id: this.getElementId(previousElement),
          previousValue: previousElement
        });
      });
      const nextElements = (elementsDetailField.nextValue || []);
      nextElements.forEach(nextElement => {
        const nextElementId = this.getElementId(nextElement);
        const existingElement = elements.find(element => element.id === nextElementId);
        if (!!existingElement) {
          existingElement.nextValue = nextElement;
        } else {
          elements.push({
            id: nextElementId,
            nextValue: nextElement
          });
        }
      });
      return elements;
    },
    getElementId: function (element: any): string {
      return (element.id || `${ element.fieldName }.${ element.fieldValue }`);
    }
  }
};
